module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ant"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The events described in this book took place over thirteen years ago. In writing the book I relied solely upon my memory and the letters I wrote home to a few friends. I did not seek professional support from medical staff at University College Hospital. Any technical explanations (or technical errors) are mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The names of many of the people in this book have been changed to protect their privacy. Some characters are not based on any one person but are composite characters.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8e6754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062032379_epub_ant_r1.vue
// module id = 66
// module chunks = 0